@if (pageLoading()) {
  <app-loading />
} @else if (pageError()) {
  <div class="flex flex-col items-center justify-center gap-4 py-20 text-center">
    <p class="text-sm text-gray-500">{{ pageError() }}</p>
    <button
      onclick="history.back()"
      class="border-primary text-primary hover-bg-primary rounded-[6px] border px-5 py-2 text-sm font-medium hover:cursor-pointer hover:text-white">
      Go Back
    </button>
  </div>
} @else if (userData()) {
  <app-user-details-component [data]="userData()!" />
}
